
import { AppConstants } from "../../../../core/constants/constants";
import InfoVideo from "../../domain/entities/InfoVideo";
import { AdminRepository } from "../../domain/repositories/AdminRepository";
import { AdminDataSource } from "../datasource/AdminDataSource";

export class AdminRepositoryImpl implements AdminRepository {
	constructor(private dataSource: AdminDataSource) {}
	getVideos(): Promise<InfoVideo[]> {
		return AppConstants.getRightOrLeftSide<InfoVideo[]>(
			this.dataSource.getVideos()
		)
	}
}
